import { SET_IS_MOBILE } from './actionTypes';

export const setIsMobile = (isMobile) => ({
  type: SET_IS_MOBILE,
  isMobile,
});